import _ from 'lodash';
import * as utils from '../../../util/utils';
import {
    RECEIVE_FILTER_IN_ASSESSMENT,
    REMOVE_FILTER_IN_ASSESSMENT,
    RECEIVE_ONLY_FILTER_IN_ASSESSMENT,
    CLEAR_ALL_FILTERS_IN_ASSESSMENT,
    INITIALIZE_ASSESSMENT_FILTER_QUEUE,
} from '../../../actions/selectedFilter/inAssessmentActions';


const InAssessmentReducer = (state = {}, action) => {
    Object.freeze(state);
    let newState = _.cloneDeep(state);

    let promptId;
    let filter;
    let position;
    if (action.payload) {
        promptId = action.payload.promptId;
        filter = action.payload.filterVal;
        position = action.payload.position;
    }

    switch (action.type) {
        case RECEIVE_FILTER_IN_ASSESSMENT:
            newState[promptId][position] = filter;

            return newState;

        case REMOVE_FILTER_IN_ASSESSMENT:
            newState[promptId][position] = null;

            return newState;

        case RECEIVE_ONLY_FILTER_IN_ASSESSMENT:
            //set filter value at the position within array and set all other filters to null to remove
            newState[promptId] = newState[promptId].map((el, idx) => {
                if (idx === position) {
                    return filter;
                } else {
                    return null;
                }
            });

            return newState;
        
        case INITIALIZE_ASSESSMENT_FILTER_QUEUE:
            newState = action.payload.initialState;

            return newState;

        case CLEAR_ALL_FILTERS_IN_ASSESSMENT:
            return {};

        default:
            return state;
    }
};

export default InAssessmentReducer;